import React, { useState, useEffect } from 'react';
import './Gallery.css';

const missionImages = [
  '../../../Images/Gallery1.png',
  '../../../Images/Gallery2.png',
  '../../../Images/Gallery3.png',
  '../../../Images/Gallery4.png',
  '../../../Images/Gallery5.png',
  '../../../Images/Gallery6.png',
  '../../../Images/Gallery7.png',
  '../../../Images/Gallery10.png',
];

const Gallery = () => {
  const [current, setCurrent] = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setTransitioning(true);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % missionImages.length);
        setTransitioning(false);
      }, 500);
    }, 4500);
    return () => clearInterval(timer);
  }, []);

  const goTo = (i) => {
    if (i === current) return;
    setTransitioning(true);
    setTimeout(() => {
      setCurrent(i);
      setTransitioning(false);
    }, 500);
  };

  const prev = () => goTo((current - 1 + missionImages.length) % missionImages.length);
  const next = () => goTo((current + 1) % missionImages.length);

  return (
    <div className="gl-page">

      {/* ── HERO ── */}
      <div className="gl-hero">
        <div className="gl-hero-bg" style={{ backgroundImage: `url(${missionImages[1]})` }} />
        <div className="gl-hero-overlay" />
        <div className="gl-hero-content">
          <h1>Gallery</h1>
        </div>
      </div>

      {/* ── MISSIONS SLIDESHOW ── */}
<section className="gl-section" style={{ paddingTop: '2rem' }}>        <div className="gl-section-inner">
          <h2>Behind the Scenes</h2>
          <p className="gl-intro">
            A glimpse of the first half of our missions.<br />
            <em>We currently don't photograph on the street.</em>
          </p>

          <div className="gl-slideshow">
            {/* Main Image */}
            <div className="gl-slide-main">
              <img
                src={missionImages[current]}
                alt={`Mission ${current + 1}`}
                className={`gl-slide-img ${transitioning ? 'gl-fade-out' : 'gl-fade-in'}`}
              />

              {/* Arrows */}
              <button className="gl-arrow gl-arrow-left" onClick={prev} aria-label="Previous">
                &#8592;
              </button>
              <button className="gl-arrow gl-arrow-right" onClick={next} aria-label="Next">
                &#8594;
              </button>

              {/* Counter */}
              <div className="gl-counter">
                {current + 1} / {missionImages.length}
              </div>
            </div>

            {/* Dot Nav */}
            <div className="gl-dots">
              {missionImages.map((_, i) => (
                <button
                  key={i}
                  className={`gl-dot ${i === current ? 'active' : ''}`}
                  onClick={() => goTo(i)}
                  aria-label={`Go to slide ${i + 1}`}
                />
              ))}
            </div>

            {/* Thumbnails */}
            <div className="gl-thumbs">
              {missionImages.map((img, i) => (
                <button
                  key={i}
                  className={`gl-thumb ${i === current ? 'active' : ''}`}
                  onClick={() => goTo(i)}
                >
                  <img src={img} alt={`Thumbnail ${i + 1}`} />
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Gallery;